import { z } from 'zod';
import { PoolReadinessConfidenceLevel } from 'libs/end-to-end/src/confidence';

export const PayBenchmarkingCompensationUnit = z.enum(['hourly', 'salary']);

export type PayBenchmarkingCompensationUnit = z.infer<
  typeof PayBenchmarkingCompensationUnit
>;

export const PayCompensationUnitDisplayValues: Record<
  PayBenchmarkingCompensationUnit,
  string
> = {
  hourly: '/hr',
  salary: '/yr',
};

export const PayBenchmarkingSelectedFilters = z.object({
  benchmark: z.string(),
  department: z.string(),
  role: z.string(),
  level: z.string(),
  location: z.string(),
  experience: z.string().optional(),
  education: z.string().optional(),
  compensationUnit: PayBenchmarkingCompensationUnit,
  currency: z.string(),
});

export type PayBenchmarkingSelectedFilters = z.infer<
  typeof PayBenchmarkingSelectedFilters
>;

export const PayBenchmarkingCompensationFigures = z.object({
  internalPayBandLowerBound: z.number(),
  internalPayBandUpperBound: z.number(),
  marketRangeLowerBound: z.number(),
  marketRangeUpperBound: z.number(),
  suggestedBaseSalary: z.number(),
  baseSalaryStatisticalConfidence: PoolReadinessConfidenceLevel,
  suggestedVariablePay: z.number(),
  variablePayStatisticalConfidence: PoolReadinessConfidenceLevel,
  suggestedTotalCompensation: z.number(),
  internalCompaRatio: z.number(),
});

export type PayBenchmarkingCompensationFigures = z.infer<
  typeof PayBenchmarkingCompensationFigures
>;

export const PayBenchmarkingLevel = z.object({
  name: z.string(),
  percentileSalary25: z.number(),
  percentileSalary50: z.number(),
  percentileSalary75: z.number(),
  percentileSalary90: z.number(),
});

export type PayBenchmarkingLevel = z.infer<typeof PayBenchmarkingLevel>;

export const PayBenchmarkingOutput = z.object({
  appliedFilters: PayBenchmarkingSelectedFilters,
  compensationFigures: PayBenchmarkingCompensationFigures,
  comparisonLevels: z.array(PayBenchmarkingLevel),
});

export type PayBenchmarkingOutput = z.infer<typeof PayBenchmarkingOutput>;
